import axios from './index';

export const loginRequest = (reqObj) => axios.post('/v1/vendors/login/vendor', reqObj);

export const registerVendorRequest = (reqObj) => axios.post(`/v1/vendors/create/vendor`, reqObj);
